module.exports = __webpack_public_path__ + "images/btn-sociallog-tw.png?58d76";